<template>
    <div>
        设置账号与广告组




    </div>

</template>

<script>

import Vue from 'vue';
import {
    Table,
    TableColumn,
    FormItem,
    Input,
    Button,
    Dialog,
    Loading,
    Form,
    MessageBox,
    Notification,
    Tabs,
    TabPane,
    Select,
    Option
} from 'element-ui';
import Pagination from '@/components/Pagination/index.vue'
import {ToolAdPlatMap} from '../../../../utils/map'

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Input)
Vue.use(Button)
Vue.use(FormItem)
Vue.use(Form)
Vue.use(Dialog)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Select)
Vue.use(Option)
Vue.use(Loading)
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$notify = Notification

export default {
    data() {
        return {
            curAdPlatId: '400',
            selectPlatformList: ToolAdPlatMap,
        }
    },
    created() {

    },
    methods: {
        startHacking() {
            console.log("button click");
        }
    }
}
</script>

<style>
#app {
    font-family: Helvetica, sans-serif;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/promotion/createBatch/account.vue